import { inject } from 'mobx-react';
import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

import { PlaybackSubHeading } from './playback-sub-heading';

interface CollapsedSearchPlaybackProps {
  searchResults?: SearchResultsStore;
}

export const CollapsedSearchPlayback: React.FunctionComponent<CollapsedSearchPlaybackProps> = inject('searchResults')(
  ({ searchResults }) => {
    const { formatText, formatDateString } = useLocalization();

    if (!searchResults) return null;
    const { searchCriteria, isLoading, searchedDestination } = searchResults;
    const { destination, guestCount } = searchCriteria || {};

    const destinationMessage = isLoading
      ? destination
      : destination || searchedDestination || formatText('hotels.searchResults.playback.destinationMissing.text');

    const getSearchDateRange = () => {
      const searchCriteria = searchResults?.searchCriteria;

      if (!searchCriteria || !searchCriteria.startDate || !searchCriteria.endDate) {
        return '';
      }

      const startDate = formatDateString(searchCriteria.startDate, { skeleton: 'MMMd' });
      const endDate = formatDateString(searchCriteria.endDate, { skeleton: 'MMMd' });

      return formatText('hotels.searchResults.playback.dateRange', startDate, endDate);
    };

    return (
      <UitkLayoutFlex dataTestId="collapsed-search-playback">
        <UitkLayoutFlexItem alignSelf="center">
          <UitkSpacing margin={{ inlinestart: 'one', inlineend: 'two' }}>
            <UitkIcon
              description={formatText('hotels.searchResults.backToSearchResults.a11yLabel')}
              id="playback-icon"
              name="search"
              size={UitkIconSize.MEDIUM}
              title={formatText('hotels.searchResults.title')}
            />
          </UitkSpacing>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <UitkSpacing margin={{ block: 'two', inlinestart: 'one' }}>
            <div>
              <PlaybackSubHeading
                destinationMessage={destinationMessage}
                dateRange={getSearchDateRange()}
                guestCountTitle={(guestCount && formatText('hotels.searchResults.numberOfGuests', guestCount)) || undefined}
              />
            </div>
          </UitkSpacing>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    );
  }
);
